import React from 'react'
import { Button, ButtonProps, Stack, StackProps, SxProps, Theme } from '@mui/material'

type StepActionsRootProps = StackProps
type ForwardButtonProps = ButtonProps
type BackwardButtonProps = ButtonProps

const commonButtonSx: SxProps<Theme> = {
  borderRadius: 9999,
  width: '100%',
}

const ForwardButton: React.FC<ForwardButtonProps> = ({ children = 'Continuar', sx, ...props }) => {
  return (
    <Button variant="contained" color="primary" disableElevation sx={{ ...commonButtonSx, ...sx }} {...props}>
      {children}
    </Button>
  )
}

const BackwardButton: React.FC<BackwardButtonProps> = ({ children = 'Voltar', sx, ...props }) => {
  return (
    <Button variant="outlined" color="primary" sx={{ ...commonButtonSx, ...sx }} {...props}>
      {children}
    </Button>
  )
}

const ChargingStepActionsRoot: React.FC<StepActionsRootProps> = ({ children, spacing = 1, ...props }) => {
  return (
    <Stack spacing={spacing} {...props}>
      {children}
    </Stack>
  )
}

export const ChargingStepActions = Object.assign(ChargingStepActionsRoot, {
  ForwardButton,
  BackwardButton,
})
